import { createSlice } from "@reduxjs/toolkit";

const VoluntarySurveyDetails = createSlice({
  name: "VoluntarySurveyDetails",
  initialState: {
    surveyInfo: {},
    surveySummary: {},
    selectedSiteInfo: {
      name: "",
      code: "",
      cameraSiteId: "",
      lastSurveyDate:"",
      latitude: "",
      longitude: "",
    },
    selectedCustomerInfo: {}
  },
  reducers: {
    SurveyInfoReducer: (state: any, action: any) => {
      state.surveyInfo = action.payload;
      return state;
    },
    SurveySummaryReducer: (state: any, action: any) => {
      state.surveySummary = action.payload;
      return state;
    },
    SelectedSiteReducer: (state: any, action: any) => {
      state.selectedSiteInfo = action.payload;
      return state;
    },
    SelectedCustomerReducer: (state: any, action: any) => {
      state.selectedCustomerInfo = action.payload;
      return state;
    }
  }
});

export const {
  SurveyInfoReducer,
  SelectedSiteReducer,
  SurveySummaryReducer,
  SelectedCustomerReducer
} = VoluntarySurveyDetails.actions;

export default VoluntarySurveyDetails;
